import { render, staticRenderFns } from "./ListaHistorial.vue?vue&type=template&id=ff97e0a8&"
import script from "./ListaHistorial.vue?vue&type=script&lang=js&"
export * from "./ListaHistorial.vue?vue&type=script&lang=js&"
import style0 from "./ListaHistorial.vue?vue&type=style&index=0&id=ff97e0a8&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports